// extracted by mini-css-extract-plugin
module.exports = {"Section":"BEToggle_Section__3ZsrK","ToggleSwitch":"BEToggle_ToggleSwitch__2VJJe"};